import { render, staticRenderFns } from "./ActivityLogs.vue?vue&type=template&id=03cb74c6&scoped=true&"
import script from "./ActivityLogs.vue?vue&type=script&lang=js&"
export * from "./ActivityLogs.vue?vue&type=script&lang=js&"
import style0 from "./ActivityLogs.vue?vue&type=style&index=0&id=03cb74c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cb74c6",
  null
  
)

export default component.exports